import CollectorLinkForm from "./CollectorLinkForm";
import { useState } from "react";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";

const UpdatedCollectorLink = () => {

    const [crumbs] = useState([
        { content: "Home", url: "/" },
        { content: "Collector Links", url: "/collector-links" },
        { content: "Update Collector Link", url: "" },
    ]);

    return (
        <>
            <CollectorLinkForm crumbs={crumbs} title={"Update Collector Link"} btnText={"Update"}
                isReadOnly={!hasPermission(["COLLINK-U"])}/>
        </>
    )
}
export default UpdatedCollectorLink;